module.exports = __webpack_public_path__ + "media/assets/white-cross-054a6cf5c2a0d277e8a0a5a3da07e0c7f6565c84577080a6938fe66ad9b048ad.svg";